/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import {
  Box,
  ChevronDownIcon,
  Flex,
  Label,
  Menu,
  MenuButton,
  MenuLink,
  MenuList,
  Text,
} from '@bottlebooks/gatsby-theme-base/src';
import { jsx } from 'theme-ui';
import useSiteLanguage from '../../../../useSiteLanguage';

export default function LanguageSwitcher({ ...rest }) {
  return null;
  const { lang, setLang } = useSiteLanguage();
  return (
    <Box {...rest}>
      <Menu>
        <MenuButton variant="text">
          <Flex align="center">
            <Box sx={{ textAlign: 'left' }}>
              <Label
                variant="small"
                sx={{ color: 'lighterText', lineHeight: '12px' }}
              >
                Language
              </Label>
              {lang === 'en' ? (
                <Text
                  variant="small"
                  sx={{ lineHeight: '16px' }}
                  className="notranslate"
                >
                  English
                </Text>
              ) : lang === 'fr' ? (
                <Text
                  variant="small"
                  sx={{ lineHeight: '16px' }}
                  className="notranslate"
                >
                  Français
                </Text>
              ) : (
                <Text
                  variant="small"
                  sx={{ lineHeight: '16px' }}
                  className="notranslate"
                >
                  Other
                </Text>
              )}
            </Box>
            <ChevronDownIcon
              sx={{ marginLeft: 1, color: 'lighterText' }}
              size="small"
            />
          </Flex>
        </MenuButton>
        <MenuList>
          <MenuLink
            onClick={() => {
              setLang({ lang: 'en' });
            }}
            className="notranslate"
          >
            English
          </MenuLink>
          <MenuLink
            onClick={() => {
              setLang({ lang: 'fr' });
            }}
            className="notranslate"
          >
            Français
          </MenuLink>
        </MenuList>
      </Menu>
    </Box>
  );
}
